import axios from "axios";
import React, { useState, useEffect } from "react";
import "./product.css";

export const HomeNews = () => {
  const [item, setItem] = useState([]);

  useEffect(() => {
    axios
      .get("/api/newsevent/getlast")
      .then((res) => {
        console.log("Data fetched:", res.data); // You can log the response data to confirm
        setItem(res.data); // Set the response data to your state
      })
      .catch((err) => {
        console.error("Error fetching data:", err); // Log any errors in fetching
      });
  }, []);

  return (
    <div>
      <section className="py-">
        <div className="container incontainer my-5">
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-8 col-xl-6">
              <div className="text-center ino-box">
                <h2 className="fw-bolder text-white" style={{ textShadow: "0 2px 4px rgba(0,0,0,0.5)" }}>Latest News</h2>
              </div>
            </div>
          </div>
          <div className="row gx-1 mx-0 px-0 row-cols-1">
            {item.map((news) => {
              return (
                <div className="row gx-4 innov-block mb-4" key={news._id}>
                  <div className="col-lg-12 mb-5 mx-3">
                    <div className="premium-card px-4 py-3">
                      <div className="row align-items-center">
                        <div className="col-md-8 mb-3 card-body text-justify p-4">
                          <a
                            className="text-decoration-none link-light stretched-link"
                            href={`/news/${news._id}`}
                          >
                            <h4 className="card-title my-3 mb-3 fw-bolder text-white">
                              {news.name}
                            </h4>
                          </a>
                          <p className="card-text mb-0 c-text-align text-white mt-3" style={{ opacity: 0.9 }}>
                            {news.shortdesc}
                          </p>
                        </div>
                        <div className="col-md-4 p-4 text-center align-self-center">
                          {news.images && news.images.length > 0 ? (
                            <img
                              src={`/newsevent/${news.images[0]}`} // Display the first image
                              alt="..."
                              className="img-fluid rounded mx-auto"
                              onError={(e) => { e.target.onerror = null; e.target.src = "https://dummyimage.com/600x400/343a40/6c757d?text=No+Image"; }}
                            />
                          ) : (
                            <span>No image available</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
